import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../models/product.models';
import {
  SupplierDto,
  SupplierDetailDto,
  PayablesReportDto,
  CreateSupplierRequest,
  UpdateSupplierRequest,
  AddSupplierPaymentRequest,
} from '../models/finance.models';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class SupplierService extends ApiService {
  private readonly endpoint = `${environment.apiUrl}/api/Suppliers`;

  getAll(search?: string, onlyWithDebt?: boolean): Observable<ApiResponse<SupplierDto[]>> {
    let params = new HttpParams();
    if (search) params = params.set('search', search);
    if (onlyWithDebt) params = params.set('onlyWithDebt', true);
    return this.http.get<ApiResponse<SupplierDto[]>>(this.endpoint, { params });
  }

  getPayables(): Observable<ApiResponse<PayablesReportDto>> {
    return this.http.get<ApiResponse<PayablesReportDto>>(`${this.endpoint}/payables`);
  }

  getById(id: string): Observable<ApiResponse<SupplierDetailDto>> {
    return this.http.get<ApiResponse<SupplierDetailDto>>(`${this.endpoint}/${id}`);
  }

  create(data: CreateSupplierRequest): Observable<ApiResponse<{ id: string }>> {
    return this.http.post<ApiResponse<{ id: string }>>(this.endpoint, data);
  }

  update(id: string, data: UpdateSupplierRequest): Observable<unknown> {
    return this.http.put(`${this.endpoint}/${id}`, data);
  }

  delete(id: string): Observable<unknown> {
    return this.http.delete(`${this.endpoint}/${id}`);
  }

  addPayment(id: string, data: AddSupplierPaymentRequest): Observable<ApiResponse<{ id: string }>> {
    return this.http.post<ApiResponse<{ id: string }>>(`${this.endpoint}/${id}/payments`, data);
  }
}
